import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AzureDatabricksIcon = props => (
  <Icon viewBox="0 0 720 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-316 0)">
      <g>
        <g>
          <path
            d="M362.2 197.2 362.2 217.68 676 394.72 956.24 236.44 956.24 300.44 676 459.64 378 290.32 362.2 299.12 362.2 421.6 676 598.2 956.24 440.52 956.24 503.96 676 663.24 378 493.88 362.2 502.68 362.2 523.44 676 700 989.8 523.44 989.8 400.84 973.8 392.12 676 561.44 395.68 402.16 395.68 339.04 676 496.56 989.8 320 989.8 199.12 973.8 190.36 676 359.72 410.08 208.6 676 58.4 895.04 182.16 914.2 171.4 914.2 154.52 676 20Z"
            fill="currentColor"
            fillRule="nonzero"
            fillOpacity="1"
          />
        </g>
      </g>
    </g>
  </Icon>
);
